<template>
    <div>
        <BACK title="新增運輸媒合" name='Home'/>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="運輸媒合類別" prop="caseType">
                <div class="clear">
                    <el-checkbox v-for="({id, name},idx) in caseType" v-model="interviewOption[idx]" :key="idx"
                                 @change="chengeJobType(idx)">{{name}}
                    </el-checkbox>
                </div>
            </el-form-item>
            <el-form-item label="車輛類型" prop="carType">
                <div class="clear">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.carType">
                        <el-option v-for="({id, name},idx) in carType" :label="name" :value="id" :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <el-form-item label="配送日期" prop="startDate">
                <div class="flex">
                    <div class="item hide_close">
                        <!-- <div class="tit">從</div> -->
                        <el-date-picker
                            v-model="startDate"
                            type="date"
                            placeholder="開始日期">
                        </el-date-picker>
                    </div>
                    <div class="item_text">至</div>
                    <div class="item hide_close">
                        <!-- <div class="tit">到</div> -->
                        <el-date-picker
                            v-model="endDate"
                            type="date"
                            align="right"
                            placeholder="結束日期">
                        </el-date-picker>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="選擇地區" prop="areaFrom">
                <div class="flex">
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaFrom"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                    <span class="text_pad color_primary">到</span>
                    <el-select class="select_area" popper-class="select_area_popper" v-model="form.areaTo"
                               placeholder="請選擇">
                        <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName" :value="areaId"
                                   :key="idx"/>
                    </el-select>
                </div>
            </el-form-item>
            <!-- <el-form-item label="金額" prop="pay">
              <el-input v-model="form.pay" type="number" maxlength="30" clearable placeholder="輸入標題"></el-input>
            </el-form-item> -->
            <el-form-item label="聯絡姓名" prop="contactName">
                <el-input v-model="form.contactName" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡人名稱"></el-input>
            </el-form-item>
            <el-form-item label="聯絡資訊" prop="contactMemo">
                <el-input v-model="form.contactMemo" type="text" maxlength="30" clearable
                          placeholder="請輸入聯絡資訊"></el-input>
            </el-form-item>
            <el-form-item label="刊登標題" prop="title">
                <el-input v-model="form.title" type="text" maxlength="30" clearable placeholder="輸入標題"></el-input>
            </el-form-item>
            <el-form-item label="內容敘述" prop="content" :validate-on-rule-change="true">
                <el-input v-model="form.content" maxlength="1000" :autosize="{ minRows: 5}" type="textarea"></el-input>
            </el-form-item>
        </el-form>
        <div class="note">*文章均遵守<span class="tag" @click="openTerms">《服務條款》</span></div>
        <div class="btn">
            <el-button type="success" :disabled="loading" @click="handleSubmit"><i class="el-icon-loading"
                                                                                   v-if="loading"></i>送出
            </el-button>
        </div>
        <DialogTerms :visbileName="'dialogTermsVisible'"/>
    </div>
</template>
<script>

    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import DialogTerms from '@/components/DialogTerms'
    import {mapActions, mapGetters} from 'vuex'
    import moment from 'moment/min/moment-with-locales'

    export default {
        name: 'add',
        components: {
            BACK,
            DialogTerms
        },
        mixins: [FN],
        data() {
            return {
                interviewOption: {
                    0: false,
                    1: false
                },
                startDate: '',
                endDate: '',
                form: {
                    title: '',
                    areaTo: '',
                    areaFrom: '',
                    caseType: '',
                    carType: '',
                    content: '',
                    startDate: '',
                    endDate: '',
                    contactName: '',
                    contactMemo: ''
                }
            }
        },
        computed: {
            ...mapGetters([
                'caseType',
                'carType',
                'searchArea'
            ]),
            rules() {
                const message = '輸入不完整'
                // 自訂驗證-interviewType
                const isCaseType = (rule, value, callback) => {
                    if (!this.interviewOption[0] && !this.interviewOption[1]) {
                        callback(new Error('請選擇運輸媒合類別'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-area
                const isArea = (rule, value, callback) => {
                    if (!this.form.areaFrom || !this.form.areaTo) {
                        callback(new Error('請選擇地區'))
                    } else {
                        callback()
                    }
                }
                // 自訂驗證-password2
                const isDate = (rule, value, callback) => {
                    if (this.startDate > this.endDate) {
                        callback(new Error('結束日期不可小於開始日期'))
                    } else {
                        callback()
                    }
                }
                return {
                    caseType: [
                        {required: true, trigger: 'change', validator: isCaseType}
                    ],
                    carType: [{required: true, trigger: 'change', message: '請選擇車輛類型'}],
                    areaFrom: [{required: true, trigger: 'change', validator: isArea}],
                    startDate: (this.startDate && this.endDate) ? [{
                        required: true,
                        trigger: 'change',
                        validator: isDate
                    }] : [],
                    title: [{required: true, trigger: 'change', message: '請輸入標題'}],
                    content: [{required: true, trigger: 'change', message: '請輸入內容敘述'}],
                    contactName: [{required: true, trigger: 'change', message: '請輸入聯絡姓名'}],
                    contactMemo: [{required: true, trigger: 'change', message: '請輸入聯絡資訊'}]
                }
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            chengeJobType(idx) {
                if (this.interviewOption[idx]) {
                    this.interviewOption[Math.abs(idx - 1)] = false
                    this.form.caseType = +this.caseType[idx].id
                }
            },
            beforeFormSubmit() {
                this.form.startDate = this.startDate ? moment(this.startDate).format('YYYYMMDD') : ''
                this.form.endDate = this.endDate ? moment(this.endDate).format('YYYYMMDD') : ''
            },
            //送出表單
            handleSubmit() {
                const form = this.$refs.form
                this.beforeValidate()
                this.clearSearchData()
                form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.beforeFormSubmit()
                        this.FETCH({
                            key: 'CASE_ADD',
                            ...this.form
                        }).then((res) => {
                            //需要accToken的驗證
                            if (+(res || {}).code === -3) {
                                this.checkNewToken(this.handleSubmit)
                            } else {
                                this.handleResponse(res)
                            }
                        })
                    } else {
                        this.loading = false
                        this.handleUnValid()
                    }
                })

            },
            //回應
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('恭喜您獲得1次抽獎機會!!',{
                        title:"文章已新增",
                        confirmButtonText: '前往抽獎',
                        cancelButtonText: '回列表',
                        type: 'success',
                        closeOnClickModal: false
                    }).then(() => {
                        this.$router.replace({name: 'Lottery'})
                    }).catch(() => {
                        this.$router.replace({name: 'Case', params: {tag: 'my'}})
                        this.$parent.handleSearch()
                    });
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            getDetail() {
                const id = this.$route.params.id
                this.FETCH({
                    key: 'CASE_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                })
            },
            handleBack() {
                this.$router.replace({name: 'Case'})
            },
            //清除搜尋資料
            clearSearchData() {
                this.$parent.qkArea = ''
                this.$parent.form.areaFrom = []
                this.$parent.form.areaTo = []
                this.$parent.form.carType = []
                this.$parent.form.caseType = ''
                this.$parent.form.startDate = ''
                this.$parent.form.endDate = ''
                this.$parent.startDate = ''
                this.$parent.endDate = ''
            },
            getMemberInfo() {
                this.FETCH({
                    key: 'USER_INFO',
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        if (!+res.code) {
                            this.form.contactName = res.data.nickname;
                            this.form.contactMemo = '電話-'+res.data.phone;
                        }
                    }
                })
            }
        },
        mounted() {
            this.getMemberInfo()
        }
    }
</script>
